@if(cardNumber() || data.cardNumber) {
<div
  class="w-full h-full md:h-[500px] md:w-[500px] flex flex-col gap-2 items-center pt-3 px-6 pb-8 bg-white font-medium rounded-[16px]"
>
  <div class="w-full flex justify-end">
    <div
      class="rounded-full w-9 h-9 bg-gray-11 text-teal-seed flex items-center justify-center font-medium cursor-pointer"
      (click)="closeDialog()"
    >
      <ng-icon name="hugeCancel01" size="24"></ng-icon>
    </div>
  </div>
  <div class="flex flex-col gap-5 items-center">
    <h1 class="text-[24px] md:text-[32px]">Member code</h1>
    <ngx-qrcode-styling [config]="config"></ngx-qrcode-styling>
    <p class="text-[24px] md:text-[32px]">Scan Qr code</p>
  </div>
</div>
}
